export default __webpack_public_path__ + "static/media/sy.332308d3.svg";